import React, { useState } from "react"
import { Field, FieldProps } from "react-final-form"

import { Visibility, VisibilityOff } from "@mui/icons-material"
import { TextFieldProps } from "@mui/material"

import { TextFieldWithAbsoluteHelperText } from "./TextField"

const PASSWORD_INPUT_ID = "password-input-id"

export const PasswordField = ({ textFieldProps, ...props }: Props) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  return <Field {...props}>
    {({ input }) => <TextFieldWithAbsoluteHelperText {...Object.assign(input, textFieldProps)} width="auto"
                               type={showPassword ? "text" : "password"}
                               onChange={(event) => {
                                 textFieldProps?.executeOnChange?.()
                                 input.onChange(event)
                               }}
                               id={textFieldProps?.id || PASSWORD_INPUT_ID}
                               endAdornment={<div
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  style={{ cursor: "pointer", display: "grid", placeItems: "center" }}
                                >
                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </div>} />}
  </Field>
}

type ExtendedTextFieldProps = TextFieldProps & { executeOnChange?: (args?: any) => any }
type Props = FieldProps<any, any> & { textFieldProps?: ExtendedTextFieldProps }
